import React, { useState } from 'react'
import {
  Form,
  Button,
} from 'react-bootstrap'
import { toast } from '@CommonComponents/toast'
import { LoadingSpinner, MEModal } from '@CommonComponents'
import { client, toTitleCase } from '@Utils'
import { useStateValue } from '@State'

export const TemplateRow = ({ tempType, template }) => {
  let [currentState, dispatch] = useStateValue()
  let [isEditing, setIsEditing] = useState(false)
  let [modalOpen, toggleModal] = useState(false)
  let [isLoading, setIsLoading] = useState(false)
  let [tempName, setTempName] = useState(template.name)
  let [designId, setDesignId] = useState(template.designId)

  const handleSave = async evt => {
    evt.preventDefault()
    setIsLoading(true)
    let tempId = template.id
    let url = '/account/admin_achievements.update_template/'

    let postData = {
      tempId: tempId,
      type: tempType,
      name: tempName,
    }
    let designKey = `${tempType}DesignId`
    postData[designKey] = designId
    postData['certifierId'] = template.certifierId
    try {
      let resp = await client.post(url, postData)
      let stateAcmts =
        tempType === 'certificate'
          ? currentState.certificates
          : currentState.badges
      let dispatchType =
        tempType === 'certificate' ? 'updateCerts' : 'updateBadges'
      let newAcmts = []
      stateAcmts.map(acmt => {
        if (acmt.id === resp.data.acmtTemplate.id) {
          newAcmts.push(resp.data.acmtTemplate)
        } else {
          newAcmts.push(acmt)
        }
      })
      dispatch({
        type: dispatchType,
        payload: newAcmts,
      })
    } catch (err) {
      let errMsg = err.response.data.msg
      toast.error(errMsg, { autoClose: false })
      setTempName(template.name)
      setDesignId(template.designId)
    }
    setIsEditing(false)
    setIsLoading(false)
  }

  const handleDelete = async (evt, tempId) => {
    evt.preventDefault()
    setIsLoading(true)
    try {
      await client.delete(
        `/account/admin_achievements.delete_template/${tempId}`
      )
      if (tempType === 'certificate') {
        let newCerts = currentState.certificates.filter(
          cert => cert.id !== tempId
        )
        dispatch({ type: 'updateCerts', payload: newCerts })
      } else {
        let newBadges = currentState.badges.filter(badge => badge.id !== tempId)
        dispatch({ type: 'updateBadges', payload: newBadges })
      }
    } catch (err) {
      let errMsg = err.response.data.msg
      toast.error(errMsg, { autoClose: false })
    }
    setIsLoading(false)
    toggleModal(false)
  }

  const handleCancel = e => {
    e.preventDefault()
    setTempName(template.name)
    setDesignId(template.designId)
    setIsEditing(false)
  }

  return (
    <div className="border my-3 p-3">
      {isEditing ? (
        <Form>
          <Form.Group>
            <Form.Label className="mb-0">{`${toTitleCase(
              tempType
            )} Name`}</Form.Label>
            <Form.Control
              type="text"
              onChange={e => setTempName(e.target.value)}
              defaultValue={tempName}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label className="mb-0">Design ID</Form.Label>
            <Form.Control
              as="select"
              value={designId}
              onChange={e => setDesignId(e.target.value)}
            >
              <option value="">Select Design</option>
              {currentState[`${tempType}Designs`].map((design, i) => (
                <option key={i} value={design.id}>
                  {`${design.name} - ${design.id}`}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
          <div className="d-flex justify-content-center">
            <span>
              <button
                className="btn btn-myed btn-default btn-default-myed btn-sm-myed mr-2"
                onClick={e => handleSave(e)}
              >
                <i className="fa-regular fa-check mr-1" />
                Save
              </button>
              <button
                className="btn btn-myed btn-default btn-default-myed btn-sm-myed text-danger"
                onClick={e => handleCancel(e)}
              >
                <i className="fa-regular fa-times mr-1" />
                Cancel
              </button>
            </span>
          </div>
        </Form>
      ) : (
        <div className="d-flex justify-content-between">
          <span className="align-self-center">{template.name}</span>
          <span className="align-self-center">{template.designId}</span>
          <div>
            <button
              className="btn btn-myed btn-default btn-default-myed btn-sm-myed mr-2"
              onClick={() => setIsEditing(true)}
            >
              <i className="fa-regular fa-edit mr-1" />
              Edit
            </button>
            <button
              onClick={() => toggleModal(true)}
              className="btn btn-myed btn-default btn-default-myed btn-sm-myed text-danger"
            >
              <i className="fa-regular fa-trash mr-1" />
              Delete
            </button>
          </div>
        </div>
      )}
      <MEModal
        show={modalOpen}
        close={() => toggleModal(false)}
        title={`Delete ${toTitleCase(tempType)} Template`}
      >
        <p>
          Are you sure you want to delete this {tempType} template:{' '}
          {template.name}?
        </p>
        <div className="d-flex justify-content-center">
          <span className="mt-3">
            <Button
              className="btn-myed btn-default-myed mr-3"
              type="button"
              variant="secondary"
              onClick={() => toggleModal(false)}
            >
              <i className="fa-regular fa-times mr-2" />
              Cancel
            </Button>
            <Button
              className="btn-myed btn-danger-myed"
              type="button"
              variant="danger"
              onClick={e => handleDelete(e, template.id)}
              disabled={isLoading}
            >
              <div className="d-flex align-items-center">
                {isLoading ? (
                  <LoadingSpinner
                    className="align-self-center"
                    style={{
                      fontSize: '15px',
                      color: 'white',
                      marginRight: '4px',
                    }}
                  />
                ) : (
                  <i className="fa-regular fa-trash mr-2" />
                )}
                <span>{isLoading ? 'Deleting' : 'Delete'}</span>
              </div>
            </Button>
          </span>
        </div>
      </MEModal>
    </div>
  )
}
